var UsersNotifications = {


    init : function(){

        $('.notifications .notifications-grid .notification .btn-delete').click(function(){
            if(confirm('Are you sure?')){
                UsersNotifications.deleteSelectedNotification($(this));
            }
            return false;
        });

        $('.notifications .delete-all').click(function(){
            if(confirm('Are you sure?')){
                UsersNotifications.deleteAllNotifications($(this));
            }
            return false;
        });
    },
    readSelectedNotification : function($this){
        var container  = $this.closest('.notification');
        var id=$($this).data('id');
        $.ajax({
            type: "PUT",
           url  : "/users/notifications/" + id,
            data: {
                id: $this.data('id')
            },
            success:function(data){
                container.find('.label-new').addClass('d-none');

                 container.find('.label-read').removeClass('d-none');
            }
        });
    },
    deleteSelectedNotification : function($this){
        var id=$($this).data('id');
        $.ajax({
            type : "DELETE",               
            url  : "/users/notifications/" + id,
            data: { 
                id: $this.data('id')
            },            
            success:function(data){
                  window.location.reload();
            }
        });
    },
    deleteAllNotifications : function($this){
        $.ajax({
            type: "DELETE", 
            url: "/users/notifications/all",     
            data: { 
                id: 'all'
            },        
            success:function(data){
                 window.location.reload();
            }
        });
        return false;
    }
};

